


























































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { VueEditor } from 'vue2-editor';
import { EditorConfig } from '../../../config';
import { NoticeBoardDto } from '@/dto';
import { NOTICE_BOARD, CONST_NOTICE_BOARD } from '@/services/shared';
import toast from '../../../../resources/assets/js/services/toast.js';

import {
  ATTACHMENT_REASON_TYPE,
  FileAttachmentDto,
} from '../../../services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import NoticeBoardService from '../../../services/notice-board.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { YN } from '@/common';

@Component({
  name: 'NoticeBoardCreate',
  components: {
    VueEditor,
  },
})
export default class NoticeBoardCreate extends BaseComponent {
  private noticeBoardCreateDto = new NoticeBoardDto();
  private htmlContent = null;
  private noticeBoardTypes: NOTICE_BOARD[] = [...CONST_NOTICE_BOARD];
  private editorToolbar = EditorConfig;
  private startDate = new Date();
  private endDate = new Date();
  private attachments = [];

  clearedOut() {
    this.noticeBoardCreateDto = new NoticeBoardDto();
  }

  async upload(files: FileList) {
    const attaching = await FileUploadService.upload(
      UPLOAD_TYPE.NOTICE_BOARD,
      files,
    );
    this.attachments.push(
      ...attaching.filter(
        fileAttachment =>
          fileAttachment.attachmentReasonType ===
          ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
  }

  deleteAttachment(attachemnt, index) {
    if (this.attachments.includes(attachemnt)) {
      index = this.attachments.indexOf(attachemnt);
      if (index > -1) {
        this.attachments.splice(index, 1);
      }
    }
  }

  create(isTempSaveYn?: YN) {
    if (this.attachments) {
      this.noticeBoardCreateDto.attachments = this.attachments;
    }
    if (isTempSaveYn === YN.NO) {
      this.noticeBoardCreateDto.tempSaveYn = YN.NO;
    }
    NoticeBoardService.create(this.noticeBoardCreateDto).subscribe(res => {
      if (res) {
        this.$router.push('/notice-board');
        if (isTempSaveYn === YN.NO) {
          toast.success('등록 완료');
        } else {
          toast.success('임시 저장 완료');
        }
      }
    });
  }
}
